import React from "react";
import { Store } from "src/store";
import { MemoryRouter as RouteProvider } from "react-router";
import ThemeProvider from "src/providers/theme/ThemeProvider";
import { Provider as StoreProvider } from "react-redux";
import FrameProvider from "src/providers/frame/FrameProvider";

interface Props {
    store: Store;
    ErrorBoundary: any;
    children: any;
    route?: [string];
}

const Providers = ({ store, ErrorBoundary, children, route }: Props) => {
    return (
        <StoreProvider store={store}>
            <RouteProvider initialEntries={route}>
                <ErrorBoundary>
                    <FrameProvider>
                        <ThemeProvider>{children}</ThemeProvider>
                    </FrameProvider>
                </ErrorBoundary>
            </RouteProvider>
        </StoreProvider>
    );
};

export default Providers;
